import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

// Minimal stand-in for the Data360 app's CustomLoader (used by EChartBase).
export function CustomLoader({ size = 40, caption = "Loading...", captionSize = "0.9rem" }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
      <CircularProgress size={Math.min(size, 48)} />
      {caption ? <Typography sx={{ fontSize: captionSize }} color="text.secondary">{caption}</Typography> : null}
    </Box>
  );
}
